import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NextPlanIcon(props: IconProps) {
    return <Icon {...props} iconKey={"next_plan"}/>
}
